import React, { createContext, useContext, useEffect, useState } from "react";
import { api, setCustomerToken, getCustomerToken } from "@/lib/api";

const CustomerContext = createContext(null);
export const useCustomer = () => useContext(CustomerContext);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function CustomerProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getCustomerToken();
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/customer/me")
      .then(({ data }) => setCustomer(data))
      .catch(() => setCustomerToken(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (mobile, password) => {
    const { data } = await api.post("/customer/login", { mobile, password });
    setCustomerToken(data.token);
    setCustomer(data.customer);
    return data.customer;
  };

  const register = async (payload) => {
    const { data } = await api.post("/customer/register", payload);
    setCustomerToken(data.token);
    setCustomer(data.customer);
    return data.customer;
  };

  const logout = () => {
    setCustomerToken(null);
    setCustomer(null);
  };

  return (
    <CustomerContext.Provider
      value={{ customer, loading, login, register, logout, setCustomer }}
    >
      {children}
    </CustomerContext.Provider>
  );
}
